import { render } from "./instructor-qa.vue?vue&type=template&id=371dc91b"
import script from "./instructor-qa.vue?vue&type=script&lang=js"
export * from "./instructor-qa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__